import React from 'react';
import { Box, Typography } from '@mui/material';
import { VerifiedUser as ShieldIcon } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';

const AtomicAnswer = ({ text }) => {
  const { t } = useTranslation();

  return (
    <Box
      component="section"
      className="atomic-answer"
      sx={{
        borderLeft: '3px solid #1E3A5F',
        bgcolor: '#FFFFFF',
        borderRadius: '0 12px 12px 0',
        boxShadow: '0 2px 12px rgba(0,0,0,0.06)',
        p: 3,
        mb: 5,
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
        <ShieldIcon sx={{ fontSize: '1rem', color: '#1E3A5F' }} />
        <Typography
          variant="overline"
          sx={{
            color: '#1E3A5F',
            fontWeight: 700,
            letterSpacing: 1.5,
            fontSize: '0.75rem',
            lineHeight: 1,
          }}
        >
          {t('atomicAnswer.overline')}
        </Typography>
      </Box>
      <Typography
        variant="body1"
        sx={{ color: '#1A1A1A', lineHeight: 1.8, fontSize: '1.0625rem' }}
      >
        {text}
      </Typography>
    </Box>
  );
};

export default AtomicAnswer;
